"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/img/bg_wid_gradient.png"));
const mobile_generate_OTP_png_1 = __importDefault(require("../../../../assets/img/mobile-generate-OTP.png"));
const mobile_token_pin_png_1 = __importDefault(require("../../../../assets/img/mobile-token-pin.png"));
const bg_field_png_1 = __importDefault(require("../../../../assets/img/bg_field.png"));
const styles_1 = require("@mui/styles");
const fontFamilyConst = '"Open Sans", Helvetica,Arial,sans-serif';
const paddingConst = '6px 10px 8px';
const displayConst = 'inline-block';
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: fontFamilyConst,
        overflow: 'hidden',
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x left bottom #fff`
    },
    DialogContentOuter: {
        width: '550px',
        paddingTop: '10px',
        backgroundColor: '#f7f7f7'
    },
    DialogNotification: {
    // position: "absolue"
    },
    DialogContent: {
        borderWidth: 0,
        width: '550px',
        overflow: 'hidden',
        padding: paddingConst,
        position: 'relative'
    },
    WrapIcon: {
        width: '169px',
        height: '345px',
        position: 'relative',
        float: 'right',
        paddingTop: '10px',
        marginTop: '73px',
        marginRight: '5px',
        background: `url(${mobile_generate_OTP_png_1.default}) no-repeat scroll 0 0 transparent`,
        display: 'block'
    },
    IconClose: {
        position: 'relative',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        marginRight: '5px',
        marginTop: '2px',
        cursor: 'pointer',
        zIndex: 1103,
        display: 'block'
    },
    ListItem: {
        marginTop: '-60px',
        overflow: 'hidden',
        padding: paddingConst,
        marginLeft: '-14px',
        position: 'relative',
        width: '535px'
    },
    ListItemText: {
        fontWeight: 'normal',
        color: '#2f3c54',
        padding: 0,
        marginTop: '44px'
    },
    StepTips: {
        width: '117%'
    },
    OTPButtonImg: {
        background: `url(${mobile_token_pin_png_1.default}) no-repeat -1px -1px`,
        width: '32px',
        height: '32px',
        position: 'relative',
        display: displayConst,
        backgroundSize: '750% 2100%',
        top: '11px'
    },
    FindOTPButtonImg: {
        background: `url(${mobile_token_pin_png_1.default}) no-repeat 1px -49px`,
        backgroundSize: '100%',
        width: '170px',
        height: '109px',
        display: displayConst
    },
    EnterOTPImg: {
        background: `url(${mobile_token_pin_png_1.default}) no-repeat 1px -265.5px`,
        backgroundSize: '100%',
        width: '170px',
        height: '109px',
        display: displayConst
    },
    FieldGroup: {
        overflow: 'hidden',
        position: 'relative',
        padding: paddingConst
    },
    StepTitle: {
        color: '#36b7a6',
        fontWeight: 'bold',
        fontSize: '13px',
        padding: 0,
        marginLeft: '-10px'
    },
    StepOTP: {
        margin: '10px 1px 0'
    },
    StepContent: {
        background: 'transparent',
        paddingLeft: 0,
        borderRadius: '5px',
        height: '70px',
        padding: '8px 10px',
        position: 'relative',
        display: displayConst,
        width: '304px'
    },
    StepTxt: {
        float: 'left'
    },
    InputOTP: {
        backgroundColor: 'transparent',
        display: displayConst,
        marginBottom: '2px',
        marginLeft: '-3px',
        padding: '4px',
        borderRadius: '5px',
        maxWidth: '100%'
    },
    OtpError: {
        color: '#ff0000',
        fontFamily: fontFamilyConst,
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-12px',
        marginTop: '3px'
    },
    typography: {
        'margin-left': '-11px',
        // 'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#2f3c54',
        fontWeight: 'normal',
        fontFamily: fontFamilyConst,
        fontSize: '12px'
    },
    OTPTitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        margin: '10px 10px 0',
        padding: '5px 0 10px',
        fontSize: '103%',
        marginTop: '15px',
        marginLeft: '19px',
        fontFamily: fontFamilyConst,
        width: '478px',
        fontStyle: 'normal'
    },
    OTP: {
        borderRadius: '2px',
        background: `url(${bg_field_png_1.default}) repeat-x left top #fff`,
        border: '1px solid',
        borderColor: '#e1e5eb',
        color: '#2f3c54',
        width: '100px',
        height: '37px',
        fontWeight: 600,
        fontSize: '13px',
        outline: '0',
        verticalAlign: 'middle',
        marginLeft: '-12px',
        maxWidth: 'inherite',
        boxSizing: 'border-box',
    },
    InputFocus: {
        border: '1px solid #869cc1',
        boxShadow: 'inset #e6e6e6 0 0 4px 0',
        zIndex: 1
    },
    InputHeight: {
        height: '37px !important'
    },
    Link: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontFamily: fontFamilyConst,
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-5px',
        cursor: 'pointer'
    },
    OTPLink: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontFamily: fontFamilyConst,
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-5px',
        cursor: 'pointer',
        paddingLeft: '4px'
    },
    SubmitOutline: {
        paddingTop: '10px',
        margin: '10px 10px 0',
        alignItems: 'center',
        flexWrap: 'wrap',
        display: 'block'
    },
    Submit: {
        boxSizing: 'border-box',
        background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
        border: '1px solid #595959',
        borderRadius: '5px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#FFF',
        display: 'block',
        float: 'left',
        fontSize: '13px',
        fontFamily: fontFamilyConst,
        height: 'auto',
        lineHeight: 'normal',
        position: 'relative',
        padding: '9px 12px',
        margin: 0,
        minWidth: '126px',
        outline: 0,
        marginLeft: '-14px',
        textTransform: 'none',
        textShadow: 'none',
        '&:hover': {
            background: 'linear-gradient(180deg, #606060 0, #505050 100%)'
        },
        '&:focus': {
            border: '1px solid #595959 !important',
            boxShadow: 'inset #e6e6e6 0 0 4px 0'
        }
    },
    ModifyMobileLink: {
        paddingTop: '15px',
        float: 'right',
        margin: '0 0 0 5px',
        color: '#1480b7',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 600
    }
}));
